import React from 'react'

import {
  Box,
  Display,
  FontFamily,
  FontWeight,
  Heading2,
  JustifyContent,
  Space,
  TextAlign,
  withCitrusTheme,
} from '@gousto-internal/citrus-react'

import { CWCLinkButton } from '../CWCLinkButton/CWCLinkButton'
import { LandingPageContentSections, trackCTAClick, TrackingActions } from '../../tracking'
import { CWC_HOW_IT_WORKS_SECTION } from './config'
import { CWCHowItWorksCarousel } from './components/CWCHowItWorksCarousel'

// Section heading — Axiforma ExtraBold 36/40, sentence case, centred, colour #1A2026 (Mirage/ink)
// per Figma 371:12578. The mobile frame wraps it to two lines naturally.
// Size comes from the Citrus `size` prop (13 = 36/40) on the element below — trap-proof, so no
// media-query re-assertion is needed. Colour, and the centring, live here. The 278px max-width
// matches the Figma heading text box so it wraps "How our recipe / boxes work" on every breakpoint;
// left-anchored on mobile/tablet, centred (margin auto) on desktop.
const SectionHeading = withCitrusTheme(Heading2, (theme) => ({
  color: '#1A2026',
  maxWidth: '278px',
  marginLeft: 0,
  marginRight: 0,
  [`@media (min-width: ${theme.tokens.breakpoints[2]})`]: {
    marginLeft: 'auto',
    marginRight: 'auto',
  },
}))

// Section background per Figma 320:11419 ("Section" fill #F2F3F4). Not a Citrus colour token, so it's
// set exactly here.
const Section = withCitrusTheme('section', () => ({
  backgroundColor: '#F2F3F4',
}))

export function CWCHowItWorksSection() {
  const trackCTA = () => {
    trackCTAClick(
      TrackingActions.HOW_GOUSTO_WORKS_CLICKED,
      LandingPageContentSections.HOW_RECIPE_BOXES_WORK,
    )
  }

  return (
    <Section data-testid="cwcHowItWorksSection">
      {/* Horizontal inset on mobile/tablet so the heading, cards and CTA align to the frame edge
          (16px mobile, 32px tablet) and the heading wraps like the design; desktop uses the full
          width and centres the static row. */}
      <Box paddingV={10} paddingH={[4, null, 8, 0]}>
        <SectionHeading
          size={13}
          textAlign={[TextAlign.Left, null, null, TextAlign.Center]}
          fontFamily={FontFamily.ExtraBold}
          fontWeight={FontWeight.Bold}
        >
          {CWC_HOW_IT_WORKS_SECTION.heading}
        </SectionHeading>
        <Space size={6} />
        <CWCHowItWorksCarousel />
        <Space size={6} />
        <Box display={Display.Flex} justifyContent={JustifyContent.Center}>
          <CWCLinkButton
            href={CWC_HOW_IT_WORKS_SECTION.cta.href}
            onClick={trackCTA}
            variant="secondary"
          >
            {CWC_HOW_IT_WORKS_SECTION.cta.label}
          </CWCLinkButton>
        </Box>
      </Box>
    </Section>
  )
}
